import OfflineNotice from "./OfflineNotice";

export default OfflineNotice;